import styled from 'styled-components';
import { Color, Grid, Shadow, Border } from '../../app/StyleGuide';

export const FeedbackCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Color.white};
  border: 1px solid ${Color.Gray._10};
  border-top: none;
  box-shadow: ${Shadow.small};
  height: 100%;
  padding: ${Grid._4};
  border-radius: 0 0 ${Border.radius} ${Border.radius};
`;
